export class ValidationMessages {
    static noMessage: any = {
        noMessage: true,
    };
}
